import axios from "axios"

const instance = axios.create({
  timeout: 30000,
  baseURL: window.location.href.startsWith("https://pay.futurespay.net") ? "https://api.futurespay.net/" : "https://api.satogate.io/",
  // baseURL: "https://api.futurespay.net/"
  // baseURL: "https://test-api.futurespay.net/"
  // baseURL: "http://10.88.10.70:8089/"
})
// 请求拦截
instance.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data)
    const headers = localStorage.getItem("headers")
    config.headers = JSON.parse(headers)
    return config
  }, 
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截
instance.interceptors.response.use(
  res => {
    if (res.status === 200) {
      let response = res.data
      if (response.code === 200) {
        return response.data
      } else {
        return Promise.reject(response.message)
      }
    } else {
      return Promise.reject(res.statusText)
    }
  }, 
  error => {
    if (error.message.includes('timeout')) {
      return Promise.reject('网络异常，请求超时')
    } else {
      return Promise.reject(error)
    }
  }
)
// 请求方法
export const post = function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance.post(url,params).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
export const get = function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    instance.get(url, { params }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
